<template>
  <div class="add-button w-100 text-align-center my-4 py-2" v-on="$listeners">
    <a-icon type="plus" />&nbsp;
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AddButton',
}
</script>

<style lang="less" scoped>
@blue-6: #1890ff;
@blue-7: #096dd9;
.add-button {
  border: 1px dashed @blue-6;
  color: @blue-6;
  cursor: pointer;
  &:hover {
    border-color: @blue-7;
    color: @blue-7;
    transition: all 0.3s;
  }
}
</style>
